module.exports = "/static/Images/es/VeryUnsatisfied.png";